(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fl-bento-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupLightbox = (root) => {
      const dialog = root.querySelector('[data-flb-lightbox]');
      const triggers = [...root.querySelectorAll('[data-flb-lightbox-trigger]')];
      if (!dialog || triggers.length === 0 || dialog.dataset.flbLightboxReady === 'true') return;

      dialog.dataset.flbLightboxReady = 'true';
      const stage = dialog.querySelector('.fl-bento__lightbox-stage');
      const image = dialog.querySelector('[data-flb-lightbox-image]');
      const caption = dialog.querySelector('[data-flb-lightbox-caption]');
      const counter = dialog.querySelector('[data-flb-lightbox-counter]');
      const previousButton = dialog.querySelector('[data-flb-lightbox-prev]');
      const nextButton = dialog.querySelector('[data-flb-lightbox-next]');
      const closeButton = dialog.querySelector('[data-flb-lightbox-close]');
      let currentIndex = 0;
      let previousFocus = null;
      let savedOverflow = '';

      const render = () => {
        const trigger = triggers[currentIndex];
        image.src = trigger.dataset.flbLightboxSrc || '';
        image.alt = trigger.dataset.flbLightboxAlt || '';
        if (caption) caption.textContent = trigger.dataset.flbLightboxCaption || '';
        if (counter) counter.textContent = `${currentIndex + 1} / ${triggers.length}`;
        const hasGallery = triggers.length > 1;
        previousButton.hidden = !hasGallery;
        nextButton.hidden = !hasGallery;
      };

      const move = (direction) => {
        currentIndex = (currentIndex + direction + triggers.length) % triggers.length;
        render();
      };

      const open = (index, trigger) => {
        currentIndex = index;
        previousFocus = trigger;
        render();
        savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        closeButton.focus({ preventScroll: true });
      };

      const close = () => {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          open(index, trigger);
        });
      });

      previousButton.addEventListener('click', () => move(-1));
      nextButton.addEventListener('click', () => move(1));
      closeButton.addEventListener('click', close);
      stage.addEventListener('click', (event) => {
        if (event.target === stage) close();
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' && triggers.length > 1) {
          event.preventDefault();
          move(-1);
        } else if (event.key === 'ArrowRight' && triggers.length > 1) {
          event.preventDefault();
          move(1);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          close();
        }
      });

      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = savedOverflow;
        image.removeAttribute('src');
        previousFocus?.focus({ preventScroll: true });
      });
    };

    const initialize = (root) => {
      if (!root || root.dataset.flbInitialized === 'true') return;
      root.dataset.flbInitialized = 'true';

      setupLightbox(root);

      const tiles = [...root.querySelectorAll('[data-flb-tile]')];
      if (!root.classList.contains('fl-bento--reveal') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        tiles.forEach((tile) => tile.classList.add('is-visible'));
        return;
      }

      root.classList.add('fl-bento--reveal-ready');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          const delay = Number.parseInt(entry.target.style.transitionDelay, 10) || 0;
          window.setTimeout(() => {
            entry.target.style.transitionDelay = '0ms';
          }, delay + 800);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          tiles.forEach((tile, index) => {
            tile.style.transitionDelay = `${Math.min(index * 90, 450)}ms`;
            observer.observe(tile);
          });
        });
      });
    };

    const initializeAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-fl-bento]')) initialize(scope);
      scope.querySelectorAll('[data-fl-bento]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-catalog-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fl-catalog-cards')) {
  customElements.define('fl-catalog-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.reveal !== 'true' || window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      const cards = [...this.querySelectorAll('.flcat-card')];
      this.observer = new IntersectionObserver(entries => {
        entries.filter(entry => entry.isIntersecting).forEach((entry, index) => {
          const card = entry.target;
          card.style.setProperty('--delay', `${index * Number(this.dataset.stagger || 0)}ms`);
          card.classList.remove('flcat-pending');
          card.classList.add('flcat-revealing');
          card.addEventListener('animationend', () => card.classList.remove('flcat-revealing'), {once: true});
          this.observer.unobserve(card);
        });
      }, {threshold: 0.05});
      cards.forEach(card => {card.classList.add('flcat-pending');this.observer.observe(card);});
      this.onFocus = event => event.target.closest('.flcat-card')?.classList.remove('flcat-pending', 'flcat-revealing');
      this.addEventListener('focusin', this.onFocus);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('focusin', this.onFocus);
      this.querySelectorAll('.flcat-card').forEach(card => card.classList.remove('flcat-pending', 'flcat-revealing'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-collection-grid')) {
    customElements.define('fl-collection-grid', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.busy = false;
        this.layoutObserver = new MutationObserver(() => this.queueAlignment());
        this.layoutObserver.observe(this, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden','class','data-variant']});
        this.layoutResize = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.layoutWidth) { this.layoutWidth = width; this.queueAlignment(); }
        });
        this.layoutResize.observe(this);
        document.fonts?.ready.then(() => { if (this.isConnected) this.queueAlignment(); });
        this.queueAlignment();
        this.addEventListener('click', event => {
          const filtered = event.target.closest('[data-past-page]');
          if (filtered) { event.preventDefault(); const panel = filtered.closest('[data-flcg-panel]'); this.showPastPage(panel, Number(filtered.dataset.pastPage), true); return; }
          const retry = event.target.closest('[data-past-retry]');
          if (retry) { this.preparePast(retry.closest('[data-flcg-panel]')); return; }
          if (event.target.closest('[data-flcg-back]')) { this.leaveGroup(); return; }
          const tab = event.target.closest('[data-flcg-tab]');
          if (tab) { this.activateTab(tab, true); return; }
          const link = event.target.closest('[data-flcg-more], [data-flcg-page]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.load(link, link.hasAttribute('data-flcg-more'), true);
        }, { signal:this.events.signal });
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-flcg-tab]');
          if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          const tabs = Array.from(this.querySelectorAll('[data-flcg-tab]')).filter(item => !item.hidden);
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          const delta = (event.key === 'ArrowRight' ? 1 : -1) * direction;
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + delta + tabs.length) % tabs.length;
          event.preventDefault();
          this.activateTab(tabs[index], true);
        }, {signal:this.events.signal});
        this.addEventListener('shopify:block:select', event => {
          const tab = Array.from(this.querySelectorAll('[data-flcg-tab]')).find(item => item.dataset.blockId === event.detail?.blockId);
          if (tab) this.activateTab(tab, false);
        }, {signal:this.events.signal});
        this.frame = requestAnimationFrame(async () => {
          await this.initRemote();
          if (!this.isConnected) return;
          const tabs = this.querySelectorAll('[data-flcg-tab]');
          if (tabs.length) {
            this.querySelector('[data-flcg-tablist]').hidden = false;
            this.dataset.tabsReady = '';
            this.prepareGroups();
            const hashPanel = location.hash.slice(1);
            const initial = Array.from(tabs).find(tab => tab.getAttribute('aria-controls') === hashPanel) || Array.from(tabs).find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0];
            this.activateTab(initial, false);
          } else this.watchNext();
          window.themeCore?.LazyLoadImages?.init();
        });
      }
      disconnectedCallback() {
        this.events.abort();
        this.remoteRequest?.abort();
        this.querySelectorAll('[data-flcg-panel]').forEach(panel => panel.pastRequest?.abort());
        this.layoutObserver?.disconnect();
        this.layoutResize?.disconnect();
        cancelAnimationFrame(this.alignFrame);
        cancelAnimationFrame(this.frame);
        this.request?.abort();
        this.observer?.disconnect();
      }
      queueAlignment() {
        cancelAnimationFrame(this.alignFrame);
        this.alignFrame = requestAnimationFrame(() => this.alignFields());
      }
      alignFields() {
        if (!this.isConnected) return;
        this.querySelectorAll('[data-flcg-card]').forEach(card => {
          const sku = card.querySelector('[data-flcg-sku]');
          const id = card.querySelector('.product-card__image-wrapper.is-active[data-variant]')?.dataset.variant;
          const value = Array.from(card.querySelector('template[data-flcg-skus]')?.content.children || []).find(item => item.dataset.id === id)?.textContent;
          if (sku && value !== undefined && sku.textContent !== value) sku.textContent = value;
        });
        const selectors = ['.product-card__main','[data-flcg-field="swatches"]','[data-flcg-field="title"]','[data-flcg-field="course"]','[data-flcg-field="subtitle"]','[data-flcg-field="product_type"]','[data-flcg-field="vendor"]','[data-flcg-field="sku"]','[data-flcg-field="price"]'];
        this.querySelectorAll('[data-flcg-grid]').forEach(grid => {
          const cards = Array.from(grid.querySelectorAll('[data-flcg-card]'));
          cards.forEach(card => selectors.forEach(selector => card.querySelector(selector)?.style.removeProperty('min-height')));
          if (this.dataset.alignFields !== 'true' || !grid.getClientRects().length) return;
          const rows = new Map();
          cards.forEach(card => {
            const top = Math.round(card.closest('.flcg__item').getBoundingClientRect().top);
            if (!rows.has(top)) rows.set(top, []);
            rows.get(top).push(card);
          });
          rows.forEach(row => selectors.forEach(selector => {
            const fields = row.map(card => card.querySelector(selector)).filter(Boolean);
            const height = Math.max(0, ...fields.map(field => field.getBoundingClientRect().height));
            fields.forEach(field => { field.style.minHeight = `${height}px`; });
          }));
        });
      }
      activePanel() {
        return Array.from(this.querySelectorAll('[data-flcg-panel]')).find(panel => !panel.hidden) || this;
      }
      prepareGroups() {
        this.tabParents = new Map();
        this.groupChildren = new Map();
        const tabs = Array.from(this.querySelectorAll('[data-flcg-tab]'));
        const parents = new Map();
        tabs.filter(tab => !tab.dataset.parentKey && tab.dataset.groupKey).forEach(tab => {
          if (!parents.has(tab.dataset.groupKey)) parents.set(tab.dataset.groupKey, tab);
        });
        tabs.forEach(tab => {
          const parent = parents.get(tab.dataset.parentKey);
          if (parent && parent !== tab) {
            this.tabParents.set(tab, parent);
            if (!this.groupChildren.has(parent)) this.groupChildren.set(parent, []);
            this.groupChildren.get(parent).push(tab);
          }
        });
      }
      showGroup(parent) {
        this.currentGroup = parent;
        this.querySelectorAll('[data-flcg-tab]').forEach(tab => {
          tab.hidden = parent ? tab !== parent && this.tabParents.get(tab) !== parent : this.tabParents.has(tab);
        });
        const back = this.querySelector('[data-flcg-back]');
        if (back) back.hidden = !parent;
        const list = this.querySelector('[data-flcg-tablist]');
        if (list) list.scrollLeft = 0;
      }
      leaveGroup() {
        const parent = this.currentGroup;
        if (!parent) return;
        this.showGroup(null);
        this.activateTab(parent, true, true);
      }
      activateTab(tab, focus, stayAtRoot = false) {
        if (!this.tabParents) this.prepareGroups();
        const parent = this.tabParents.get(tab) || (this.groupChildren.has(tab) ? tab : null);
        this.showGroup(stayAtRoot ? null : parent);
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (!panel || !this.contains(panel)) return;
        this.observer?.disconnect();
        this.request?.abort();
        this.request = null;
        this.busy = false;
        this.querySelectorAll('[data-flcg-grid]').forEach(grid => grid.setAttribute('aria-busy','false'));
        this.querySelectorAll('[aria-disabled=true]').forEach(link => link.removeAttribute('aria-disabled'));
        this.querySelectorAll('[data-flcg-status]').forEach(status => { if (status.textContent === this.dataset.loading) status.textContent = ''; });
        this.querySelectorAll('[data-flcg-tab]').forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected',String(selected));
          item.tabIndex = selected ? 0 : -1;
          const target = document.getElementById(item.getAttribute('aria-controls'));
          if (target) {
            target.hidden = !selected;
            target.setAttribute('role','tabpanel');
            target.setAttribute('aria-labelledby',item.id);
            target.tabIndex = 0;
          }
        });
        if (focus) {
          tab.focus({preventScroll:true});
          const list = tab.closest('[data-flcg-tablist]');
          const box = tab.getBoundingClientRect(), bounds = list.getBoundingClientRect();
          if (box.left < bounds.left) list.scrollLeft += box.left - bounds.left;
          else if (box.right > bounds.right) list.scrollLeft += box.right - bounds.right;
        }
        window.themeCore?.LazyLoadImages?.init();
        this.watchNext();
      }
      watchNext() {
        this.observer?.disconnect();
        const panel = this.activePanel();
        if (panel.hasAttribute('data-past-filter') || panel.hasAttribute('data-remote')) {
          if (panel.hasAttribute('data-remote') && !panel.hasAttribute('data-past-ready')) return;
          if (!panel.hasAttribute('data-past-ready')) { this.preparePast(panel); return; }
          if (this.dataset.mode === 'auto' && 'IntersectionObserver' in window) {
            const next = panel.querySelector('[data-past-page]');
            if (next) { this.observer = new IntersectionObserver(entries => { if(entries.some(e => e.isIntersecting)) this.showPastPage(panel,Number(next.dataset.pastPage),false); },{rootMargin:'160px'});this.observer.observe(next); }
          }
          return;
        }
        if (this.dataset.mode !== 'auto' || !('IntersectionObserver' in window)) return;
        const next = this.activePanel().querySelector('[data-flcg-more]');
        if (!next) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && !this.busy) {
            this.observer.disconnect();
            this.load(next, true, false);
          }
        }, {rootMargin:'160px'});
        this.observer.observe(next);
      }
      async initRemote() {
        const panels = [...this.querySelectorAll('[data-remote]')];
        if (!panels.length) return;
        this.remoteRequest?.abort();
        const request = this.remoteRequest = new AbortController();
        const limit = Math.min(10,Math.max(1,Number(this.dataset.remoteLimit)||8));
        const fetchTemplate = async (url, selector) => {
          const response = await fetch(url,{signal:request.signal});
          if(response.status === 404) return [];
          if(!response.ok) throw new Error('Products unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const template = doc.querySelector(`#${CSS.escape(this.id)} ${selector}`);
          if(!template) throw new Error('Missing product template');
          return [...template.content.querySelectorAll('[data-product-id]')];
        };
        await Promise.all(panels.map(async panel => {
          try {
            let cards = [];
            if(panel.dataset.remote === 'recommendations' && this.dataset.currentProduct) {
              const url = new URL(this.dataset.recommendationsUrl,location.origin);
              url.searchParams.set('product_id',this.dataset.currentProduct);
              url.searchParams.set('section_id',this.dataset.sectionId);
              url.searchParams.set('limit',String(limit));
              url.searchParams.set('intent',this.dataset.recommendationIntent||'related');
              cards = await fetchTemplate(url,'template[data-flcg-recommendations]');
            } else if(panel.dataset.remote === 'recent') {
              let handles = [];
              try { const stored=JSON.parse(localStorage.getItem('theme_recently_viewed')||'[]');if(Array.isArray(stored))handles=stored; } catch (_) {}
              handles = [...new Set(handles.filter(h=>typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(h) && h!==this.dataset.currentHandle).reverse())].slice(0,limit);
              const results = await Promise.allSettled(handles.map(handle=> {
                const url=new URL(`${this.dataset.rootUrl.replace(/\/$/,'')}/products/${encodeURIComponent(handle)}`,location.origin);
                url.searchParams.set('section_id',this.dataset.sectionId);
                return fetchTemplate(url,'template[data-flcg-recent-card]');
              }));
              cards=results.flatMap(result=>result.status==='fulfilled'?result.value:[]);
              if(handles.length && results.every(result=>result.status==='rejected')) throw new Error('Recently viewed unavailable');
            }
            if(request.signal.aborted || !this.isConnected) return;
            const unique = new Map();
            cards.forEach(card=>{if(card.dataset.productId!==this.dataset.currentProduct && !(this.dataset.courseHide==='true' && card.dataset.past==='true'))unique.set(card.dataset.productId,card);});
            panel.pastCards=[...unique.values()];
            if(!panel.pastCards.length && this.dataset.designMode!=='true') {
              this.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`)?.remove();panel.remove();return;
            }
            panel.setAttribute('data-past-ready','');
            this.showPastPage(panel,1,false);
            if(!panel.pastCards.length && this.dataset.designMode==='true')panel.querySelector('[data-flcg-status]').textContent=panel.dataset.remote==='recent'?'Set for nylig vises, når besøgende har set andre produkter.':'Ingen anbefalinger. Vis sektionen på en produktside med anbefalinger.';
          } catch(error) {
            if(error.name!=='AbortError')panel.querySelector('[data-flcg-status]').textContent=this.dataset.error;
          }
        }));
        if(request.signal.aborted) return;
        if(!this.querySelector('[data-flcg-panel]') && this.dataset.designMode!=='true') this.hidden=true;
      }
      async preparePast(panel) {
        if (panel.pastRequest || !panel.querySelector('[data-flcg-grid][data-page]')) return;
        const request = new AbortController(); panel.pastRequest = request;
        const grid = panel.querySelector('[data-flcg-grid]'), status = panel.querySelector('[data-flcg-status]');
        panel.setAttribute('data-past-loading',''); panel.removeAttribute('data-past-error');
        status.textContent = this.dataset.loading; grid.setAttribute('aria-busy','true');
        try {
          let pageGrid = grid, url = null;
          if (Number(grid.dataset.page) !== 1) { url = new URL(location.href);url.searchParams.set(grid.dataset.pageParam,'1'); }
          const cards = new Map(), visited = new Set();
          while (true) {
            if (url) {
              url = new URL(url,location.href);
              if(url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid pagination');
              visited.add(url.href);url.searchParams.set('section_id',this.dataset.sectionId);url.hash='';
              const response = await fetch(url,{signal:request.signal});
              if(!response.ok) throw new Error('Fetch failed');
              const doc = new DOMParser().parseFromString(await response.text(),'text/html');
              pageGrid = doc.getElementById(panel.id)?.querySelector('[data-flcg-grid]');
              if(!pageGrid) throw new Error('Missing grid');
            }
            pageGrid.querySelectorAll('[data-product-id]').forEach(card => {if(card.dataset.past !== 'true') cards.set(card.dataset.productId,card);});
            url = pageGrid.dataset.next;
            if(!url) break;
          }
          if(!this.isConnected || request.signal.aborted) return;
          panel.pastCards = [...cards.values()];panel.setAttribute('data-past-ready','');
          this.showPastPage(panel,1,false);
        } catch(error) {
          if(error.name !== 'AbortError') { panel.setAttribute('data-past-error',''); status.textContent=this.dataset.error;const retry=document.createElement('button');retry.type='button';retry.dataset.pastRetry='';retry.textContent='Prøv igen';status.append(' ',retry); }
        } finally {panel.pastRequest=null;panel.removeAttribute('data-past-loading');grid.setAttribute('aria-busy','false');}
      }
      showPastPage(panel,page,focus) {
        const all = panel.pastCards || [], size = Number(this.dataset.pageSize)||12;
        const start = this.dataset.mode === 'pages' ? (page-1)*size : 0;
        const cards = all.slice(start,page*size), grid=panel.querySelector('[data-flcg-grid]'), controls=panel.querySelector('[data-flcg-controls]');
        grid.replaceChildren(...cards);grid.dataset.total=String(all.length);
        if(!all.length){const empty=document.createElement('p');empty.className='flcg__empty';empty.textContent=this.dataset.emptyLabel;grid.append(empty);}
        controls.replaceChildren();
        const button=(label,target)=>{const b=document.createElement('button');b.type='button';b.className='flcg__more';b.dataset.pastPage=String(target);b.textContent=label;controls.append(b);};
        if(this.dataset.mode === 'pages') {
          for(let i=1;i<=Math.ceil(all.length/size);i++){button(String(i),i);if(i===page){controls.lastChild.setAttribute('aria-current','page');controls.lastChild.disabled=true;}}
        } else if(page*size<all.length) button(this.dataset.moreLabel,page+1);
        const message=this.dataset.loaded.replace('[count]',String(cards.length)).replace('[total]',String(all.length));
        panel.querySelector('[data-flcg-status]').textContent=message;
        const count=panel.querySelector('.flcg__count');if(count)count.textContent=message;
        window.themeCore?.LazyLoadImages?.init();this.queueAlignment();
        if(focus)(cards[this.dataset.mode==='pages'?0:Math.max(0,(page-1)*size)]?.querySelector('a[href],button')||controls.querySelector('button'))?.focus({preventScroll:true});
        if(!panel.hidden)this.watchNext();
      }
      async load(link, append, userInitiated) {
        if (this.busy) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin) return;
        const panel = link.closest('[data-flcg-panel]') || this;
        if (panel.hidden) return;
        const grid = panel.querySelector('[data-flcg-grid]');
        const controls = panel.querySelector('[data-flcg-controls]');
        const status = panel.querySelector('[data-flcg-status]');
        if (!grid || !controls) return;
        this.busy = true;
        this.observer?.disconnect();
        this.request = new AbortController();
        const activeRequest = this.request;
        grid.setAttribute('aria-busy','true');
        link.setAttribute('aria-disabled','true');
        status.textContent = this.dataset.loading;
        url.hash = '';
        url.searchParams.set('section_id',this.dataset.sectionId);
        try {
          const response = await fetch(url, {signal:this.request.signal});
          if (!response.ok) throw new Error('Section response failed');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          if (!this.isConnected || this.request !== activeRequest) return;
          const nextSection = doc.getElementById(panel.id);
          const nextGrid = nextSection?.querySelector('[data-flcg-grid]');
          const nextControls = nextSection?.querySelector('[data-flcg-controls]');
          if (!nextGrid || !nextControls) throw new Error('Section response missing');
          const incoming = Array.from(nextGrid.children);
          const existing = new Set(Array.from(grid.children, node => node.dataset.productId));
          const additions = append ? incoming.filter(node => !existing.has(node.dataset.productId)) : incoming;
          if (append && !additions.length) throw new Error('No new products returned');
          if (!append) grid.replaceChildren();
          grid.append(...additions);
          controls.replaceChildren(...nextControls.childNodes);
          if (append) controls.querySelector('[data-flcg-page]')?.remove();
          grid.dataset.total = nextGrid.dataset.total || grid.dataset.total;
          status.textContent = this.dataset.loaded.replace('[count]',String(grid.querySelectorAll('[data-product-id]').length)).replace('[total]',grid.dataset.total);
          window.themeCore?.LazyLoadImages?.init();
          if (userInitiated) {
            const focusTarget = additions[0]?.querySelector('a[href],button') || controls.querySelector('a');
            focusTarget?.focus({preventScroll:append});
          }
          this.busy = false;
          this.watchNext();
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected && this.request === activeRequest) status.textContent = this.dataset.error;
        } finally {
          if (this.request === activeRequest) {
            this.busy = false;
            grid.setAttribute('aria-busy','false');
            link.removeAttribute('aria-disabled');
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-course-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fl-course-grid')) {
  customElements.define('fl-course-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.cards = [...this.querySelectorAll('[data-flcrg-card]')];
      this.limit = Number(this.dataset.initial) || 8;
      this.brand = '';
      this.filters = this.querySelector('[data-filters]');
      this.more = this.querySelector('[data-more]');
      this.status = this.querySelector('[data-status]');
      if (this.filters) {
        this.filters.querySelectorAll('[data-generated]').forEach(button => button.remove());
        [...new Set(this.cards.map(card => card.dataset.brand).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'da')).forEach(brand => {
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.brand = brand; button.dataset.generated = '';
          button.textContent = brand; button.setAttribute('aria-pressed','false'); this.filters.append(button);
        });
        this.filters.hidden = this.filters.children.length < 2;
        this.filters.addEventListener('click',event => {
          const button = event.target.closest('button[data-brand]');
          if (!button) return;
          this.brand = button.dataset.brand; this.limit = Number(this.dataset.initial) || 8; this.update();
        },options);
      }
      this.more.addEventListener('click',()=>{
        const previous = this.matching().slice(0,this.limit);
        this.limit += Number(this.dataset.step) || 4; this.update();
        const firstNew = this.matching().find(card=>!previous.includes(card));
        firstNew?.querySelector('.flcrg-title a')?.focus({preventScroll:true});
      },options);
      document.addEventListener('shopify:block:select',event=>{
        const card = event.target.closest('[data-flcrg-card]');
        if (!card || !this.contains(card)) return;
        this.brand = ''; this.limit = Math.max(this.limit,this.cards.indexOf(card)+1); this.update();
      },options);
      this.resize = new ResizeObserver(()=>{
        if (this.previousWidth === this.clientWidth) return;
        this.previousWidth = this.clientWidth; this.alignRows();
      });
      this.resize.observe(this);
      document.fonts?.ready.then(()=>{if(this.isConnected)this.alignRows();});
      this.update();
    }
    matching() { return this.cards.filter(card=>!this.brand || card.dataset.brand===this.brand); }
    update() {
      const matching = this.matching(); const shown = new Set(matching.slice(0,this.limit));
      this.cards.forEach(card=>card.hidden=!shown.has(card));
      this.filters?.querySelectorAll('button[data-brand]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.brand===this.brand)));
      this.more.hidden = shown.size >= matching.length;
      if(this.status)this.status.textContent = this.dataset.counter.replaceAll('[count]',shown.size).replaceAll('[total]',matching.length);
      this.alignRows();
    }
    alignRows() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(()=>{
        const visible=this.cards.filter(card=>!card.hidden);
        visible.forEach(card=>card.querySelectorAll('[data-align-row]').forEach(slot=>slot.style.minHeight=''));
        const rows=new Map();
        visible.forEach(card=>{const top=card.offsetTop; if(!rows.has(top))rows.set(top,[]); rows.get(top).push(card);});
        rows.forEach(cards=>{
          const slots=cards.map(card=>[...card.querySelectorAll('[data-align-row]')]);
          for(let i=0;i<(slots[0]?.length||0);i++) {
            const height=Math.max(...slots.map(row=>row[i].getBoundingClientRect().height));
            slots.forEach(row=>row[i].style.minHeight=`${height}px`);
          }
        });
      });
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-dynamic-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-fl-dynamic-text]';
    const controllerKey = '__flDynamicTextController';

    if (window[controllerKey]) {
      window[controllerKey].refresh(document);
      return;
    }

    const initialize = (root) => {
      if (!root || root.dataset.fldtInitialized === 'true') return;

      const viewport = root.querySelector('[data-fldt-viewport]');
      const line = root.querySelector('.fl-dynamic-text__line');
      const items = [...root.querySelectorAll('[data-fldt-item]')];
      if (!viewport || !line || !items.length) return;

      root.dataset.fldtInitialized = 'true';
      let currentIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      let timer = null;
      let typingTimer = null;
      let layoutFrame = null;
      let lastObservedWidth = -1;
      let stopped = false;
      const pause = Math.max(Number(root.dataset.pause) || 2600, 200);
      const duration = Math.max(Number(root.dataset.duration) || 500, 0);
      const shouldRotate = root.dataset.autoRotate === 'true' && items.length > 1;
      const shouldLoop = root.dataset.loop === 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const isTypewriter = root.dataset.animation === 'typewriter';
      const typewriterUnit = root.dataset.typewriterUnit === 'words' ? 'words' : 'characters';
      const typewriterChunk = Math.max(Number(root.dataset.typewriterChunk) || 1, 1);
      const typewriterSpeed = Math.max(Number(root.dataset.typewriterSpeed) || 80, 20);
      const originalSegments = new Map(items.map((item) => [
        item,
        [...item.querySelectorAll('[data-fldt-segment]')].map((element) => ({
          element,
          text: element.textContent || ''
        }))
      ]));

      const restoreItem = (item) => {
        (originalSegments.get(item) || []).forEach(({ element, text }) => {
          element.textContent = text;
        });
      };

      const restoreAll = () => items.forEach(restoreItem);

      const getTypingUnits = (item) => {
        const units = [];
        (originalSegments.get(item) || []).forEach(({ text }, segmentIndex) => {
          const parts = typewriterUnit === 'words'
            ? (text.match(/\S+\s*/g) || [])
            : Array.from(text);
          parts.forEach((value) => units.push({ segmentIndex, value }));
        });
        return units;
      };

      const renderTypingUnits = (item, units, visibleCount) => {
        const segments = originalSegments.get(item) || [];
        const values = segments.map(() => '');
        units.slice(0, visibleCount).forEach(({ segmentIndex, value }) => {
          values[segmentIndex] += value;
        });
        segments.forEach(({ element }, index) => {
          element.textContent = values[index];
        });
      };

      const setCurrentDimensions = (index) => {
        const widths = (viewport.dataset.widths || '').split(',').map(Number);
        const heights = (viewport.dataset.heights || '').split(',').map(Number);
        if (root.dataset.widthMode === 'current' && widths[index]) {
          viewport.style.setProperty('--fldt-viewport-width', `${widths[index]}px`);
        }
        if (heights[index]) viewport.style.setProperty('--fldt-viewport-height', `${heights[index]}px`);
      };

      const startTypewriter = (item) => {
        window.clearTimeout(typingTimer);
        restoreItem(item);
        const units = getTypingUnits(item);
        let visibleCount = 0;
        renderTypingUnits(item, units, visibleCount);

        const write = () => {
          visibleCount = Math.min(visibleCount + typewriterChunk, units.length);
          renderTypingUnits(item, units, visibleCount);
          if (root.dataset.widthMode === 'current') {
            viewport.style.setProperty('--fldt-viewport-width', `${Math.ceil(item.scrollWidth)}px`);
          }
          if (visibleCount < units.length) typingTimer = window.setTimeout(write, typewriterSpeed);
        };

        if (units.length) typingTimer = window.setTimeout(write, typewriterSpeed);
      };

      const getTypewriterDuration = (item) => {
        if (!isTypewriter) return duration;
        return Math.ceil(getTypingUnits(item).length / typewriterChunk) * typewriterSpeed;
      };

      const getIntrinsicItemWidth = (item) => {
        const segments = [...item.querySelectorAll('[data-fldt-segment]')].filter((segment) => segment.textContent !== '');
        const style = window.getComputedStyle(item);
        const gap = parseFloat(style.columnGap) || 0;
        const padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
        const segmentWidth = segments.reduce((total, segment) => total + segment.scrollWidth, 0);
        return Math.ceil(segmentWidth + Math.max(segments.length - 1, 0) * gap + padding);
      };

      const measure = (useLongestWidth = false) => {
        const wrapMode = root.classList.contains('fl-dynamic-text--wrap');
        const widths = items.map(getIntrinsicItemWidth);
        const heights = items.map((item) => {
          const segmentSizes = [...item.querySelectorAll('[data-fldt-segment]')].map((segment) => (
            parseFloat(window.getComputedStyle(segment).fontSize) || 0
          ));
          const breathingRoom = Math.max(...segmentSizes, 0) * .18;
          return Math.ceil(item.scrollHeight + breathingRoom);
        });
        const targetWidth = useLongestWidth || root.dataset.widthMode !== 'current'
          ? Math.max(...widths)
          : widths[currentIndex];
        viewport.style.setProperty('--fldt-viewport-width', `${targetWidth}px`);
        viewport.style.setProperty('--fldt-viewport-height', `${Math.max(...heights)}px`);
        viewport.dataset.widths = widths.join(',');
        viewport.dataset.heights = heights.join(',');
      };

      const layout = () => {
        layoutFrame = null;
        const wrapMode = root.classList.contains('fl-dynamic-text--wrap');
        restoreAll();
        root.style.setProperty('--fldt-fit-scale', '1');
        measure(true);

        if (root.dataset.autoFit === 'true' && !wrapMode) {
          const minimumScale = Math.max(
            Number(mobileQuery.matches ? root.dataset.minScaleMobile : root.dataset.minScaleDesktop) || .4,
            .2
          );
          const availableWidth = Math.max(line.clientWidth - 2, 1);
          const requiredWidth = Math.max(line.scrollWidth, 1);
          let scale = Math.min(1, availableWidth / requiredWidth);
          scale = Math.max(minimumScale, scale);
          root.style.setProperty('--fldt-fit-scale', scale.toFixed(4));
          measure(true);

          if (line.scrollWidth > availableWidth + 1 && scale > minimumScale) {
            scale = Math.max(minimumScale, scale * (availableWidth / line.scrollWidth));
            root.style.setProperty('--fldt-fit-scale', scale.toFixed(4));
            measure(true);
          }
        }

        measure(false);
        if (isTypewriter && items[currentIndex].classList.contains('is-active')) startTypewriter(items[currentIndex]);
      };

      const queueLayout = () => {
        window.cancelAnimationFrame(layoutFrame);
        layoutFrame = window.requestAnimationFrame(layout);
      };

      const activate = (nextIndex, restart = true) => {
        if (nextIndex < 0 || nextIndex >= items.length || nextIndex === currentIndex) return;
        const current = items[currentIndex];
        const next = items[nextIndex];
        window.clearTimeout(typingTimer);
        restoreItem(current);

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        next.classList.remove('is-leaving');
        void next.offsetWidth;
        next.classList.add('is-active');
        currentIndex = nextIndex;
        setCurrentDimensions(nextIndex);
        if (isTypewriter) startTypewriter(next);

        window.setTimeout(() => current.classList.remove('is-leaving'), duration + 30);
        if (restart) schedule();
      };

      const schedule = () => {
        window.clearTimeout(timer);
        if (!shouldRotate || stopped || reduceMotion.matches) return;
        timer = window.setTimeout(() => {
          const nextIndex = currentIndex + 1;
          if (nextIndex >= items.length) {
            if (!shouldLoop) {
              stopped = true;
              return;
            }
            activate(0, false);
          } else {
            activate(nextIndex, false);
          }
          schedule();
        }, pause + getTypewriterDuration(items[currentIndex]));
      };

      const pauseRotation = () => window.clearTimeout(timer);
      const resumeRotation = () => schedule();

      requestAnimationFrame(() => {
        layout();
        schedule();
      });

      if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueLayout);

      if (root.dataset.pauseHover === 'true') {
        root.addEventListener('mouseenter', pauseRotation);
        root.addEventListener('mouseleave', resumeRotation);
        root.addEventListener('focusin', pauseRotation);
        root.addEventListener('focusout', resumeRotation);
      }

      const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver((entries) => {
        const nextWidth = Math.round(entries[0]?.contentRect.width || 0);
        if (!nextWidth || nextWidth === lastObservedWidth) return;
        lastObservedWidth = nextWidth;
        queueLayout();
      }) : null;
      if (resizeObserver) resizeObserver.observe(root.querySelector('.fl-dynamic-text__content'));

      root.fldtCleanup = () => {
        window.clearTimeout(timer);
        window.clearTimeout(typingTimer);
        window.cancelAnimationFrame(layoutFrame);
        if (resizeObserver) resizeObserver.disconnect();
        if (root.dataset.pauseHover === 'true') {
          root.removeEventListener('mouseenter', pauseRotation);
          root.removeEventListener('mouseleave', resumeRotation);
          root.removeEventListener('focusin', pauseRotation);
          root.removeEventListener('focusout', resumeRotation);
        }
        delete root.dataset.fldtInitialized;
      };
      root.fldtActivateBlock = (blockId) => {
        const index = items.findIndex((item) => item.dataset.blockId === blockId);
        if (index >= 0) activate(index);
      };
    };

    const initializeAll = (scope = document) => {
      if (scope.matches && scope.matches(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    const forceInitializeAll = (scope = document) => {
      const roots = [];
      if (scope.matches && scope.matches(selector)) roots.push(scope);
      scope.querySelectorAll?.(selector).forEach((root) => roots.push(root));
      roots.forEach((root) => {
        if (root.fldtCleanup) root.fldtCleanup();
        delete root.dataset.fldtInitialized;
        initialize(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => forceInitializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
      if (root && root.fldtCleanup) root.fldtCleanup();
    });
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest?.(selector);
      if (root && root.fldtActivateBlock) root.fldtActivateBlock(event.detail.blockId);
    });

    const pendingRoots = new Set();
    let mutationFrame = null;
    const addRoot = (node) => {
      if (!node) return;
      const element = node.nodeType === 1 ? node : node.parentElement;
      if (!element) return;
      if (element.matches?.(selector)) pendingRoots.add(element);
      if (element.matches?.('[data-fldt-item]')) {
        const closestRoot = element.closest?.(selector);
        if (closestRoot) pendingRoots.add(closestRoot);
      }
      element.querySelectorAll?.(selector).forEach((root) => pendingRoots.add(root));
    };
    const mutationObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach(addRoot);
      });
      if (!pendingRoots.size) return;
      window.cancelAnimationFrame(mutationFrame);
      mutationFrame = window.requestAnimationFrame(() => {
        pendingRoots.forEach((root) => {
          if (root.isConnected) forceInitializeAll(root);
        });
        pendingRoots.clear();
      });
    });
    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window[controllerKey] = {
      refresh: forceInitializeAll
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('fl-instagram-feed')) return;

    class FlInstagramFeed extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        this.grid = this.querySelector('[data-feed-grid]');
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.handleViewportChange = () => this.load();
        this.mobileQuery.addEventListener('change', this.handleViewportChange);
        this.load();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
      }

      getLimit() {
        const value = this.mobileQuery.matches ? this.dataset.limitMobile : this.dataset.limitDesktop;
        return Math.min(Math.max(Number(value) || 6, 2), 16);
      }

      async load() {
        const endpoint = this.dataset.endpoint;
        const limit = this.getLimit();

        if (this.posts?.length >= limit) {
          this.render(this.posts.slice(0, limit));
          return;
        }

        if (!endpoint) {
          this.showStatus(this.dataset.editor === 'true' ? this.dataset.errorLabel : '');
          return;
        }

        try {
          const url = new URL(endpoint, window.location.origin);
          url.searchParams.set('limit', String(limit));
          const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Feed request failed: ${response.status}`);
          const payload = await response.json();
          const posts = Array.isArray(payload.posts) ? payload.posts.slice(0, limit) : [];
          if (!posts.length) throw new Error('Feed contained no posts');
          this.posts = posts;
          this.render(posts);
        } catch (error) {
          console.warn('[FL Instagram Feed]', error);
          this.showStatus(this.dataset.editor === 'true' ? this.dataset.errorLabel : '');
        }
      }

      render(posts) {
        const fragment = document.createDocumentFragment();
        posts.forEach((post) => {
          if (!post || !post.image_url || !post.permalink) return;
          const link = document.createElement('a');
          link.className = 'fli__item';
          link.href = post.permalink;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';

          const image = document.createElement('img');
          image.className = 'fli__image';
          image.src = post.image_url;
          image.alt = (post.caption || this.dataset.openLabel).slice(0, 180);
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 800;
          image.height = 800;
          link.appendChild(image);

          const showCaption = this.dataset.showCaption === 'true' && post.caption;
          const postIconStyle = this.dataset.postIconStyle;
          const postIconUrl = this.dataset.postIconUrl;
          const showPostIcon = Boolean(postIconUrl) || postIconStyle === 'instagram' || postIconStyle === 'arrow';
          const showMediaTypeIcon = this.dataset.showMediaTypeIcons === 'true' && (post.media_type === 'VIDEO' || post.media_type === 'CAROUSEL_ALBUM');

          if (showCaption || showPostIcon) {
            const overlay = document.createElement('span');
            overlay.className = 'fli__overlay';

            if (showCaption) {
              const caption = document.createElement('span');
              caption.className = 'fli__caption';
              caption.textContent = post.caption;
              overlay.appendChild(caption);
            }

            if (showPostIcon) {
              const meta = document.createElement('span');
              meta.className = 'fli__meta';
              meta.setAttribute('aria-hidden', 'true');

              if (postIconUrl) {
                const customIcon = document.createElement('img');
                customIcon.className = 'fli__post-custom-icon';
                customIcon.src = postIconUrl;
                customIcon.alt = '';
                customIcon.width = 22;
                customIcon.height = 22;
                meta.appendChild(customIcon);
              } else if (postIconStyle === 'instagram') {
                const instagramIcon = document.createElement('span');
                instagramIcon.className = 'fli__instagram-icon';
                meta.appendChild(instagramIcon);
              } else if (postIconStyle === 'arrow') {
                const arrowIcon = document.createElement('span');
                arrowIcon.className = 'fli__text-icon';
                arrowIcon.textContent = '↗';
                meta.appendChild(arrowIcon);
              } else {
                meta.appendChild(document.createElement('span'));
              }

              overlay.appendChild(meta);
            }

            link.appendChild(overlay);
          }

          if (showMediaTypeIcon) {
            const typeIcon = document.createElement('span');
            typeIcon.className = `fli__media-type-icon fli__type-icon--${post.media_type === 'VIDEO' ? 'video' : 'carousel'}`;
            typeIcon.setAttribute('aria-hidden', 'true');
            link.appendChild(typeIcon);
          }
          fragment.appendChild(link);
        });

        if (!fragment.childNodes.length) {
          this.showStatus(this.dataset.editor === 'true' ? this.dataset.errorLabel : '');
          return;
        }
        this.grid.replaceChildren(fragment);
        this.grid.setAttribute('aria-busy', 'false');
      }

      showStatus(message) {
        this.grid.replaceChildren();
        this.grid.setAttribute('aria-busy', 'false');
        if (!message) {
          this.hidden = true;
          return;
        }
        const status = document.createElement('p');
        status.className = 'fli__status';
        status.textContent = message;
        this.grid.appendChild(status);
      }
    }

    customElements.define('fl-instagram-feed', FlInstagramFeed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-video-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.flvsInitialized === 'true') return;
      root.dataset.flvsInitialized = 'true';

      const video = root.querySelector('.fl-video-story__video');
      const button = root.querySelector('[data-flvs-play]');
      if (!video || !button) return;

      const syncButton = () => {
        const paused = video.paused;
        button.classList.toggle('is-paused', paused);
        button.setAttribute('aria-pressed', paused ? 'false' : 'true');
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      };

      button.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => syncButton());
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', syncButton);
      video.addEventListener('pause', syncButton);
      video.addEventListener('ended', syncButton);
      syncButton();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('.fl-video-story').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
